import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=bfce4aa2&scoped=true&"
import script from "./CreateNotification.vue?vue&type=script&lang=js&"
export * from "./CreateNotification.vue?vue&type=script&lang=js&"
import style0 from "./CreateNotification.vue?vue&type=style&index=0&id=bfce4aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfce4aa2",
  null
  
)

export default component.exports